(() => {
  const labels = document.currentScript.dataset;
  const attempts = new WeakMap();

  function showMessage(button, text, attempt) {
    if (!button.isConnected || attempts.get(button) !== attempt) return;
    const message = document.createElement('span');
    message.setAttribute('role', 'status');
    message.setAttribute('aria-live', 'polite');
    message.style.cssText = 'position:absolute;left:50%;top:100%;transform:translateX(-50%);margin-top:6px;padding:5px 10px;border-radius:5px;background:#405238;color:#fff;font:600 14px/1.4 Arial,sans-serif;white-space:nowrap;pointer-events:none;z-index:10';
    const position = button.style.position;
    button.style.position = 'relative';
    message.textContent = text;
    button.append(message);
    setTimeout(() => {
      message.remove();
      if (attempts.get(button) === attempt) button.style.position = position;
    }, 2200);
  }

  document.addEventListener('click', (event) => {
    const path = event.composedPath();
    if (!path.some((node) => node.id === 'app-embed-container-1202906')) return;
    const button = path.find((node) => node.tagName === 'BUTTON');
    if (!button || button.disabled) return;
    const code = button.querySelector('span')?.textContent.trim();
    if (code !== 'WELCOME10' || !button.querySelector('svg title') || !navigator.clipboard?.writeText) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    button.querySelector('[role="status"]')?.remove();
    const attempt = {};
    attempts.set(button, attempt);
    try {
      Promise.resolve(navigator.clipboard.writeText(code)).then(
        () => showMessage(button, labels.copiedLabel, attempt),
        () => showMessage(button, labels.copyErrorLabel, attempt)
      );
    } catch {
      showMessage(button, labels.copyErrorLabel, attempt);
    }
  }, true);
})();
